module.exports = __webpack_public_path__ + "static/media/group--freezing-temperatures--dark.61d31749.svg";